import { Card, Elevation, H5, Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'

import styles from './NotFound.module.scss'

export default () => {
    return <>
        <Card className={styles.card} interactive={false} elevation={Elevation.TWO}>
            <H5><Icon icon={IconNames.Geosearch} /> 404 NotFound <Icon icon={IconNames.Geosearch} /></H5>
        </Card>
    </>

}